import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Mail, Lock, Hammer } from 'lucide-react';
import { cn } from '../../utils/formatters';
import { input, label } from '../../styles/components';

export function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg('Entrando...');
    try {
      const res = await login({ email, password, rememberMe: false });
      if (!res.success) {
        setMsg(res.error || 'Error al entrar');
        return;
      }
      navigate('/dashboard');
    } catch {
      setMsg('Error al entrar');
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-3">
        <Link to="/" className="inline-flex items-center gap-2">
          <span className="w-12 h-12 rounded-xl flex items-center justify-center bg-[var(--b2b-accent)]">
            <Hammer className="w-7 h-7 text-white" />
          </span>
          <span className="text-2xl font-extrabold tracking-tight">ReformAll</span>
        </Link>
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight">Iniciar sesión</h1>
          <p className="b2b-muted">Gestiona tus reformas de forma profesional</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="b2b-panel p-6 sm:p-8 space-y-5">
        <div>
          <label className={label} htmlFor="email">Email</label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 b2b-muted" />
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className={cn(input, 'pl-9')}
              placeholder="tu@email.com"
              autoComplete="email"
            />
          </div>
        </div>

        <div>
          <label className={label} htmlFor="password">Contraseña</label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 b2b-muted" />
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className={cn(input, 'pl-9')}
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>
        </div>

        {msg && <p className="text-center text-sm b2b-muted">{msg}</p>}

        <button type="submit" className="b2b-btn b2b-btn--primary w-full justify-center">
          Entrar
        </button>

        <p className="text-center text-sm">
          <Link to="/forgot-password" className="font-medium text-[color:var(--b2b-accent-strong)] hover:underline">¿Olvidaste tu contraseña?</Link>
        </p>

        <p className="text-center text-sm b2b-muted">
          ¿No tienes cuenta?{' '}
          <Link to="/register" className="font-medium text-[color:var(--b2b-accent-strong)] hover:underline">Crear una</Link>
        </p>
      </form>
    </div>
  );
}
